import $ from 'jquery';
import { gsap, TimelineMax, Power2, Power4, CSSRulePlugin, ScrollTrigger } from 'gsap/all';
require("../__vendor/SplitText.min.js");

gsap.registerPlugin(CSSRulePlugin, ScrollTrigger); 

const loader = () => {
	$("html, body").animate({
		scrollTop: 0
	}, 100);

	var loaderTl = new TimelineMax();

	loaderTl.to(".main--line", 0.35, {
		autoAlpha: 1,
		stagger: {
			amount: 0.55,
			from: $(window).width() > 991 ? "center" : "start"
		}
	}).set(".main", {
		className: "+=main main-step-1"
	}, 1.5).set(".main", {
		className: "+=main main-step-2"
	}, 2.65).to("#main--title-1", 0.85, {
		autoAlpha: 1
	}, 2.9).set(".main", {
		className: "+=main main-step-3"
	}, 3.95).set(".main", {
		className: "+=main main-step-4"
	}, 5.2).to(".main", 0.1, {
		onComplete: function() {
			circlePositioning();
		}
	}, 5.8)
	
	.to("#main--title-1", 0.5, {
		autoAlpha: 0
	}, 5.35).set(".main", {
		className: "+=main  main-step-4 main-step-5"
	}, 6)
	
	.to("#main--title-2", 0.85, {
		autoAlpha: 1
	}, 5.95)
	
	.set(".main", {
	   className: "+=main  main-step-4 main-step-5 main-step-6"
	}, 7.025).to("#main--title-2", 0.5, {
	   autoAlpha: 0
	}, 6.85).to("#main--title-3", 0.5, {
	   autoAlpha: 1
	}, 7.1)
	
	.set(".main-overflow", {
		className: "+=main-overflow main-overflow-active"
	}, 8.5).to("#main--title-3", 0.5, {
	   autoAlpha: 0
	}, 8.8).to("#main--title-4", 0.85, {
	   autoAlpha: 1
	}, 9.4).to(".header", 0.5, {
		y: 0
	}, 8.5).set("body", {
		className: "+=body--active"
	}, 8.5).staggerTo(".logo img, .menu > li > a", 0.6, {
		autoAlpha: 1,
		y: 0
	}, 0.1, 9).set(".main-second--wrapper", {
		className: "+=main-second--wrapper main-second--wrapper--marquee"
	}, 9.5);

	function circlePositioning() {
		$(".main--line").each(function(index, element) {
			let itemSizes = $(this).find("span")[0].getBoundingClientRect(),
				translateVerticalVh = (itemSizes.y / $(window).height() * 100) + 'vh';

			$(".main--title").text($(this).find("span")[0].length);

			$(element).attr("data-height", itemSizes.height + "px");
			$(element).attr("data-y", itemSizes.y + "px");

			$(element).find("span").remove();
			$(element).find("div").css({
				display: 'block',
				height: itemSizes.height + "px",
				bottom: translateVerticalVh
			});
		});
	}
};

export default loader;